<template>
  <v-card id="cw-confirmation-dialog--dialog__failure-technical">
    <v-card-title id="cw-confirmation-dialog__title" class="text-h5">
      <translate>
        Technical malfunction
      </translate>
    </v-card-title>
    <v-card-text id="cw-confirmation-dialog__text">
      <p v-translate>
        Due to a technical malfunction, the loan application processing has been suspended.
        Please try creating a new application later.
      </p>
      <p v-translate>
        We apologize for the inconvenience caused by this error.
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        id="cw-confirmation-dialog__confirm"
        :loading="$wait.waiting('confirmation_dialog__confirm_processing')"
        :disabled="$wait.waiting('confirmation_dialog__confirm_processing')"
        color="primary"
        text
        @click="
          $emit('dialog-cancel');
          $eventLogger.clickEvent($event);
        "
      >
        <translate>
          Close
        </translate>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CwDialogFailureTechnical',
};
</script>
